import { DASHBOARD_EXCLUDED_ASSOCIATION_CONTEXT_NAMES } from '#constants/dashboard-message-filters';
import type { GetMessagesQueryVariables } from '#graphql/generated';

export type NpMessageBlockTarget = 'all' | 'raw' | 'document' | 'message';

export type BuildGetMessagesVariablesInput =
  | { kind: 'dashboard-filtered' }
  | { kind: 'dashboard-all' }
  | { kind: 'document'; documentId: string };

/** Maps np-message block `target` to GET_MESSAGES query kind. */
export function targetToQueryKind(
  target: NpMessageBlockTarget,
): BuildGetMessagesVariablesInput['kind'] {
  switch (target) {
    case 'all':
      return 'dashboard-filtered';
    case 'raw':
    case 'message':
      return 'dashboard-all';
    case 'document':
      return 'document';
  }
}

export function buildGetMessagesVariablesForNpMessageTarget(
  target: NpMessageBlockTarget,
  documentId: string,
): GetMessagesQueryVariables {
  const kind = targetToQueryKind(target);
  if (kind === 'document') {
    return buildGetMessagesVariables({ kind: 'document', documentId });
  }

  return buildGetMessagesVariables({ kind });
}

export function buildGetMessagesVariables(
  input: BuildGetMessagesVariablesInput,
): GetMessagesQueryVariables {
  switch (input.kind) {
    case 'dashboard-filtered':
      return {
        input: {
          excludeContextNames: [
            ...DASHBOARD_EXCLUDED_ASSOCIATION_CONTEXT_NAMES,
          ],
        },
      };
    case 'dashboard-all':
      return {};
    case 'document':
      return {
        input: {
          contextFilters: [{ name: 'documentId', value: input.documentId }],
        },
      };
  }
}
